import { Button, Modal } from "react-bootstrap";
import { useState } from "react";
import Switch from "react-switch";
import {Row} from "react-bootstrap";
import {FormLabel} from "react-bootstrap";
import { use } from "react";
import UserDataService from './services/user.serviceaux'

function KitchenFastQuoteSpecialNotes(props) { 
  const [lgShow, setLgShow] = useState(false);
  const user = props.user;

  // This is how you make the current user available on any functional component
  //const { user } = useSelector(state => state.auth);

  const handleClose = () => setLgShow(false);
  const handleShow = () => {
    setLgShow(true); 
  };

  const handleUserVerification = () => {
    // Check if user is verified
    UserDataService.get(user.id).then(response => {
      if (response.data[0].isVerified) {
        handleShow();
      } else {
        alert("Please, verify your email address to save your design.");
      }
    }).catch(e => {
      console.log("Error fetching user data:", e);
      alert("An error occurred while checking user verification status. Please try again later.");
    });
  };

  return (
    <>
      <Button onClick={handleUserVerification} variant="success">{"Save Design"}</Button>        
      <Modal
        size="lg"
        show={lgShow}
        onHide={() => setLgShow(false)}
        aria-labelledby="example-modal-sizes-title-lg"
      >
        <Modal.Header closeButton>
          <Modal.Title id="example-modal-sizes-title-lg">
            {'Save your Design'}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>
            Do you want to add special notes to your design?
          </p>
          <textarea onChange={props.onChangeSpecialNotes}
            style={{height:'100px',width:'100%',padding:'10px'}}
          >
            {props.specialnotes}
          </textarea>
        </Modal.Body>
        <Modal.Footer>
          <div style={{display:'flex', flexDirection:'row',flexWrap:'wrap',justifyItems:'center',alignItems:'center',gap:'50px',alignContent:'baseline'}}>
            <div style={{display:'flex', flexDirection:'row',flexWrap:'wrap',justifyItems:'center',alignItems:'center',gap:'10px',alignContent:'baseline'}}>
              <div className='d-flex justify-content-start align-items-center gap-4'>
                <Switch
                  className="react-switch"
                  checked={props.saveAsNew || !props.locationstate}
                  onChange={props.onChangeSaveAsNew}
                  disabled={!props.locationstate}
                />                                  
              </div>
              <label>Save as New</label>                    
            </div> 
          

            <Button onClick={() => {props.onSave();setLgShow(false);}}>
              Save
            </Button>
          </div>
        </Modal.Footer>

      </Modal>
    </>
  )
}

export default KitchenFastQuoteSpecialNotes;

